<template>
  <modal id="ajuda-requisito-modal" :titulo="titulo">

    <div class="card">
      <div class="card-body">
        <div v-html="texto"></div>
      </div>
    </div>

  </modal>
</template>

<script>

import Modal from "@/components/Modal.vue";

export default {
    name: "Ajuda",
    components: {
      Modal
    },

    props: {
      ajuda: String,
      titulo: {type : String, default : 'Texto de Ajuda'},
    },

    computed:{
      texto(){
          //let ajudaFormatada = ajuda.replace(/<a\s+href=/gi, '<a target="_blank" href=');
        return (this.ajuda || '').split('<a').join('<a target="_blank"');
      }
    },

  }
</script>
